import { useContext, useEffect, useMemo, useState } from "react";

import { StoreContext } from "../store";
import moment from "moment";
import {
  dismissAnnouncement,
  getDismissedAnnouncementIds,
} from "../utils/announcementDismiss";

export default function useAnnouncements(type) {
  const store = useContext(StoreContext);
  const [index, setIndex] = useState(0);
  const [dismissedIds, setDismissedIds] = useState([]);

  useEffect(() => {
    setDismissedIds(getDismissedAnnouncementIds());
  }, []);

  useEffect(() => {
    if (!type) {
      return;
    }
    store.announcement.fetchActive(type);
  }, [type, store]);

  const all = store.announcement.items?.[type] || [];

  const items = useMemo(() => {
    const dismissed = new Set(dismissedIds);
    return all.filter((announcement) => {
      if (announcement.isActive === false) {
        return false;
      }
      const now = moment();
      if (announcement.startAt && moment(announcement.startAt).isAfter(now)) {
        return false;
      }
      if (announcement.endAt && moment(announcement.endAt).isBefore(now)) {
        return false;
      }
      if (dismissed.has(announcement._id)) {
        return false;
      }
      return true;
    });
  }, [all, dismissedIds]);

  useEffect(() => {
    if (index > 0 && index >= items.length) {
      setIndex(items.length ? items.length - 1 : 0);
    }
  }, [items.length, index]);

  const currentIndex = items.length ? Math.min(index, items.length - 1) : 0;
  const current = items[currentIndex] || null;

  const next = () =>
    setIndex((i) => (items.length ? (i + 1) % items.length : 0));
  const prev = () =>
    setIndex((i) => (items.length ? (i - 1 + items.length) % items.length : 0));

  const dismiss = (id) => {
    dismissAnnouncement(id);
    setDismissedIds(getDismissedAnnouncementIds());
  };

  return { items, currentIndex, current, next, prev, setIndex, dismiss };
}